module.exports = __webpack_public_path__ + "img/9.bf023401.jpg";